module.exports.CONNECTED = 'connected';
module.exports.DELETE_THING = 'deleteThing';
module.exports.DELETE_THINGS = 'deleteThings';
module.exports.EVENT_OCCURRED = 'eventOccurred';
module.exports.PROPERTY_STATUS = 'propertyStatus';
module.exports.REFRESH_THINGS = 'refreshThings';
module.exports.DELETE_GROUP = 'deleteGroup';
module.exports.DELETE_GROUPS = 'deleteGroups';

module.exports.ThingFormat = {
  INTERACTIVE: 0,
  EXPANDED: 1,
  LINK_ICON: 2,
};
